export enum InterviewType {
  InPerson = 'in_person',
  Phone = 'phone',
  Online = 'online',
}

export const INTERVIEW_TYPE_I18N = {
  [InterviewType.InPerson]: 'Persönlich',
  [InterviewType.Online]: 'Online',
  [InterviewType.Phone]: 'Telefon',
};
